import { ChatMessage } from "@/models/chat/chat-message";

export class ConversationGroup {
	TimeStamp: Date = new Date();
	Seperator: String = "";
	Messages: ChatMessage[] = [];

	constructor(data?: any) {
		if (!data) return;
		this.TimeStamp = data.TimeStamp;
		this.Messages = data.Messages;
		this.Seperator = data.Seperator;
	}

}
